import { Navigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { useAdminAuth } from "./AdminAuthContext";

export default function ProtectedAdminRoute({ children }) {
  const { user, checking } = useAdminAuth();
  if (checking) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <Loader2 className="h-6 w-6 animate-spin text-primary" />
      </div>
    );
  }
  if (!user) return <Navigate to="/admin" replace />;
  return children;
}
